import React from 'react'
import classNames from 'classnames'
import { CrossClientQueryResultMatch, CrossClientQueryResultMatches } from '../../../../models/CrossClient'
import { ReactComponent as MatchIcon } from '../../../../assets/images/cross-client-match.svg'
import { ReactComponent as NoMatchIcon } from '../../../../assets/images/cross-client-no-match.svg'
import { ReactComponent as PartialMatchIcon } from '../../../../assets/images/cross-client-partial-match.svg'

interface IconProps {
  width?: number | string
  height?: number | string
}

export interface CrossClientResultMatchProps {
  match: CrossClientQueryResultMatch
  onClick?: () => void
  className?: string
  iconWidth?: number | string
  iconHeight?: number | string
}

const MATCH_MAPPING: Record<CrossClientQueryResultMatch, { Icon: React.FC<IconProps>; label: string }> = {
  [CrossClientQueryResultMatches.MATCH]: { Icon: MatchIcon, label: 'Match' },
  [CrossClientQueryResultMatches.NO_MATCH]: { Icon: NoMatchIcon, label: 'No match' },
  [CrossClientQueryResultMatches.PARTIAL]: { Icon: PartialMatchIcon, label: 'Potential' },
}

export const CrossClientResultMatch: React.FC<CrossClientResultMatchProps> = ({
  match,
  onClick,
  className = 'px-2 py-1 gap-2 cross-client-match border border-1 zocks-border-0.5 zocks-border-color-gray-300 bg-white',
  iconWidth = 16,
  iconHeight = 16,
}) => {
  const { Icon, label: matchLabel } = MATCH_MAPPING[match] ?? { Icon: null, label: '' }

  return (
    <div
      className={classNames('d-flex align-items-center text-nowrap', className, {
        'cursor-pointer': !!onClick,
      })}
      role={onClick ? 'button' : undefined}
      onClick={onClick}
    >
      {Icon && <Icon width={iconWidth} height={iconHeight} />}
      <div className='paragraph-small medium'>{matchLabel}</div>
    </div>
  )
}
